import { 
  Attestation, 
  AttestationFormData, 
  AttestationStatus,
  AttestationResponse,
  AttestationStatusResponse,
  AttestationsListResponse
} from '@/types/attestation'
import { apiClient } from './api'

class AttestationService {
  private api = apiClient

  async getAttestationStatus(): Promise<AttestationStatus> {
    try {
      const response = await this.api.get<AttestationStatusResponse>('/attestations/status')
      
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to get attestation status')
      }
      
      return response.data.data
    } catch (error) {
      console.error('Get attestation status failed:', error)
      throw error
    }
  }

  async createAttestation(formData: AttestationFormData): Promise<Attestation> {
    try {
      const response = await this.api.post<AttestationResponse>('/attestations', formData)
      
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to create attestation')
      }
      
      return response.data.data
    } catch (error) {
      console.error('Create attestation failed:', error)
      throw error
    }
  }

  async getUserAttestations(): Promise<Attestation[]> {
    try {
      const response = await this.api.get<AttestationsListResponse>('/attestations')
      
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to get user attestations')
      }
      
      return response.data.data
    } catch (error) {
      console.error('Get user attestations failed:', error)
      throw error
    }
  }
}

export const attestationService = new AttestationService() 